import React from "react";
import { FormErrors } from "redux-form";

import { Form } from "@/mk2/components/Form";
import { InputField } from "@/mk2/components/forms/InputField";
import { TextareaField } from "@/mk2/components/forms/TextareaField";
import { ComposeToolbar, FIXED } from "@/mk2/containers/Toolbar/Toolbar";
import { MKReduxFormInjectedProps, mkReduxForm } from "@/mk2/decorators/mkReduxForm";
import { Photo } from "@/mk2/decorators/withUploader";
import { UserEntity } from "@/mk2/schemas";
import {
    FAQ_FORM_USERNAME,
    FAQ_FORM_WE_WILL_ANSWER_SOON,
    FAQ_YOU_DID_NOT_ENTER_DESCRIPTION,
    HELP_FORM_ISSUE,
    HELP_FORM_TOPIC,
    HELP_FORM_WHATS_NEXT_EMAIL,
} from "@/mk/autogenerated/translations/FaqAskQuestionForm.500d60d3124561ca9d673ea5b2cfb55d";
import { isAuthenticated } from "@/mk/bazaar/common/userUtils";

import styles from "./FaqAskQuestionForm.mscss";

export const FAQ_ASK_QUESTION_FORM_NAME = "FAQ_ASK_QUESTION_FORM_NAME";

export interface FaqAskQuestionFormData {
    clientInfo?: any;
    email: string;
    message: string;
    photos: Photo[];
    username: string;
}

interface OwnProps {
    initialValues: FaqAskQuestionFormData;
    isMobile: boolean;
    question: string;
    requestUser: UserEntity;

    onSave(values: FaqAskQuestionFormData);
}

type Props = OwnProps;

const photosConfig = {
    multiple: true,
    photoType: "help",
    previewPhotoSize: "s150x150",
    showPhotoCode: false,
};

class FaqAskQuestionFormComponent extends React.Component<
    Props & MKReduxFormInjectedProps<FaqAskQuestionFormData, Props>
> {
    public static validate(values: FaqAskQuestionFormData): FormErrors<FaqAskQuestionFormData> {
        const errors: FormErrors<FaqAskQuestionFormData> = {};
        if (!values.message) {
            errors.message = FAQ_YOU_DID_NOT_ENTER_DESCRIPTION;
        }

        return errors;
    }

    public render() {
        const { handleSubmit, isMobile, question, requestUser } = this.props;

        return (
            <Form className={styles.FaqAskQuestionForm} onSubmit={handleSubmit}>
                <div className={styles.FaqAskQuestionForm__question}>
                    <div className={styles.FaqAskQuestionForm__question__caption}>
                        {HELP_FORM_TOPIC}
                    </div>
                    <div>{question}</div>
                </div>

                {!isAuthenticated(requestUser) && (
                    <InputField name="email" type="text" label="E-mail" />
                )}

                {!isAuthenticated(requestUser) && (
                    <InputField name="username" type="text" label={FAQ_FORM_USERNAME} />
                )}

                <TextareaField
                    name="message"
                    label={HELP_FORM_ISSUE}
                    rows={isMobile ? 10 : 25}
                    maxRows={isMobile ? 10 : 25}
                    bottomBorder={false}
                    fillRemainingSpace
                />

                <div className={styles.FaqAskQuestionForm__notes}>
                    <div>{HELP_FORM_WHATS_NEXT_EMAIL}</div>
                    <div className={styles.FaqAskQuestionForm__notes__note2}>
                        {FAQ_FORM_WE_WILL_ANSWER_SOON}
                    </div>
                </div>

                <ComposeToolbar
                    formName={FAQ_ASK_QUESTION_FORM_NAME}
                    isFixed={FIXED.IF_MOBILE_BUT_IOS}
                    photos={photosConfig}
                    stickers={false}
                />
            </Form>
        );
    }
}

export const FaqAskQuestionForm = mkReduxForm<FaqAskQuestionFormData, Props>({
    formName: FAQ_ASK_QUESTION_FORM_NAME,
    photosConfig,
    onValidate: (values) => FaqAskQuestionFormComponent.validate(values),
    onSave: (values, props) => props.onSave(values),
})(FaqAskQuestionFormComponent);
